export enum RPCErrorCode {
    UNRECOGNIZED_CHAIN = 4902,
    REJECTED = 4001,
    INVALID_PARAMS = -32602,
    INTERNAL_ERROR = -32603
}